import React from "react";
import LinkButton from "components/Buttons/LinkButton";
import classNames from "classnames";
import styles from "./Link.module.scss";

interface Props {
    href?: string;
    children: string;
    className?: string;
}

const Link = ({ href, children, className }: Props) => {
    if (!href) {
        return null;
    }

    return (
        <LinkButton className={classNames(styles["link"], className)} href={href.replace(/&amp;/g, "&")}>
            {children}
        </LinkButton>
    );
};

export default Link;
